export default __webpack_public_path__ + "static/media/horizontales-HC1.777f85e5.jpg";